<!--
  The single most important indicator in the product.

  Renders icon + text + colour + treatment. An operator must be able to read it from
  across a studio, and a screen-reader user must get the same information: the mode is
  announced through a live region when it changes.
-->
<script setup lang="ts">
import { computed } from 'vue';
import { ON_AIR_PRESENTATION, type OnAirMode } from '../onair.js';
import { icon } from '../icons.js';

const props = withDefaults(defineProps<{ mode: OnAirMode; size?: 'default' | 'large' }>(), {
  size: 'default',
});

const presentation = computed(() => ON_AIR_PRESENTATION[props.mode]);
const IconComponent = computed(() => icon(presentation.value.icon));
</script>

<template>
  <span
    class="shio-badge shio-onair"
    :class="[presentation.className, size === 'large' && 'shio-onair--large']"
  >
    <component :is="IconComponent" :size="size === 'large' ? 18 : 13" aria-hidden="true" />
    <span>{{ presentation.label }}</span>
    <span class="shio-sr-only" role="status" aria-live="polite">{{
      presentation.announcement
    }}</span>
  </span>
</template>

<style scoped>
.shio-onair {
  gap: var(--shio-space-2);
  padding: 3px var(--shio-space-3);
}

.shio-onair--large {
  font-size: 14px;
  letter-spacing: 0.1em;
  padding: var(--shio-space-2) var(--shio-space-4);
}
</style>
